// src/lib/gtm.ts

const GTM_ID = import.meta.env.VITE_GTM_ID

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
  }
}

export function initGTM() {
  if (typeof window === "undefined") return
  if (!GTM_ID) return

  // Prevent duplicate initialization
  if (document.getElementById("google-tag-manager")) return

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  })

  const script = document.createElement("script")

  script.id = "google-tag-manager"
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`

  document.head.appendChild(script)
}

export function trackPageView(path: string) {
  if (typeof window === "undefined") return

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: "page_view",
    page_path: path,
  })
}

export const gtmTracking = (event: any) => {
  if (window && (window as any).dataLayer) {
    ;(window as any).dataLayer.push(event)
  } else {
    console.log("gtm tracking", event)
  }
}
